
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.73 7.315l7.345 7.246 7.187-7.239a1 1 0 111.42 1.41l-7.89 7.946a1 1 0 01-1.412.007L3.326 8.739a1 1 0 011.405-1.424z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    